import React from 'react';
import { Link } from 'react-router-dom';

const AppFooter = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="border-t border-border bg-background/60 py-4 px-4 md:px-6"
      data-testid="appshell-footer"
    >
      <div className="flex flex-col md:flex-row items-center justify-between gap-2 md:gap-4 text-[11px] tracking-[0.16em] uppercase text-muted-foreground">
        <div className="flex items-center gap-3">
          <span className="font-display font-bold text-foreground tracking-tight normal-case text-sm">
            FrameFlow
          </span>
          <span className="hidden sm:inline">·</span>
          <span className="hidden sm:inline">© {year} FrameFlow. Precision Engineered.</span>
        </div>
        <div className="flex items-center gap-4">
          <Link
            to="/privacy"
            className="hover:text-primary transition-colors"
            data-testid="appshell-footer-privacy-link"
          >
            Privacy Policy
          </Link>
          <Link
            to="/terms"
            className="hover:text-primary transition-colors"
            data-testid="appshell-footer-terms-link"
          >
            Terms of Service
          </Link>
          <Link
            to="/help"
            className="hover:text-primary transition-colors"
            data-testid="appshell-footer-help-link"
          >
            Help Center
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
